import { getPrice } from '../../common/utils/priceUtil';
export const getCabinBaggagePrice = (name, form) => state => getPrice(name, form)(state);
//# sourceMappingURL=price.js.map